import { PaperTrailLogStore } from '../stores/paperTrailLogs';
import { cleanCompaniesStore, getCompaniesSelect } from './companies';
import { setUiTotal } from './ui';
import { getUsersSelect } from './users';
import { apiManager } from '../REST';
import { IPaperTrailLogsItem, IPaperTrailLogsItemAPI, IPaperTrailLogsListAPI, IParamsList } from '../interfaces';
import { mapApi2UiField } from '../instruments';

function formatPaperTrailLogsList(list: IPaperTrailLogsItemAPI[]): IPaperTrailLogsItem[] {
    return list.map((values) => {
        return mapApi2UiField(values);
    });
}

export function setPaperTrailLogsList(list: IPaperTrailLogsItem[]): void {
    const PaperTrailLogInstance = PaperTrailLogStore.getInstance();
    PaperTrailLogInstance.setPaperTrailLogsList(list);
}

export function getPaperTrailLogsRelationSelect(): void {
    getCompaniesSelect();
    getUsersSelect({ isActivityLogUsers: false, pageSize: 100 });
}

export async function getPaperTrailLogsList(params: IParamsList): Promise<void> {
    const { resp } = await apiManager.getApi('GET_PAPER_TRAIL_LOGS_LIST', { searchParamsList: params });
    const { versions, meta } = resp as IPaperTrailLogsListAPI;
    meta && setUiTotal(meta.records_count);
    versions && setPaperTrailLogsList(formatPaperTrailLogsList(versions as IPaperTrailLogsItemAPI[]));
}

export function setPaperTrailLogsForcedUpdateTime(): void {
    const PaperTrailLogInstance = PaperTrailLogStore.getInstance();
    PaperTrailLogInstance.setForcedUpdateTime();
}

export function cleanPaperTrailLogsStore(): void {
    cleanCompaniesStore();
    const PaperTrailLogInstance = PaperTrailLogStore.getInstance();
    PaperTrailLogInstance.cleanStore();
}
